<script lang="ts">
    import { TenantStore } from "$/stores/TenantStore";
    import CopyTopicDropdownItem from "./CopyTopicDropdownItem.svelte";
    import type { Tenant } from "./types";

    export let showMoreOptionsMenu: boolean;

    $: tenants = ($TenantStore.tenants || []) as Tenant[];

    let copyComments = false;
</script>

<div
    class="custom-z-index absolute right-0 min-w-max overflow-hidden rounded-md border border-solid border-neutral-200 bg-white text-sm shadow-xl"
>
    <div
        class="custom-max-height w-64 overflow-auto p-1"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
    >
        {#if tenants}
            {#each tenants as tenant}
                <CopyTopicDropdownItem
                    bind:showMoreOptionsMenu
                    bind:copyComments
                    {tenant}
                />
            {/each}
        {:else}
            <div class="min-w-52">Loading...</div>
        {/if}
    </div>
    <div class="flex items-center gap-2 border-t bg-white p-2 pl-4">
        <input id="copy-comments" type="checkbox" bind:checked={copyComments} />
        <label for="copy-comments" class="w-full">Copy comments</label>
    </div>
</div>

<style>
    .custom-z-index {
        @apply z-[60];
    }
    .custom-max-height {
        @apply max-h-[60vh];
    }
</style>
